import React from 'react';
function MoveDown({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M12 6L12 15" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 18L19 18" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 11L12 15L8 11" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default MoveDown;
